import type { CacheOptions } from "@warp-drive/core/types/request";
import { createRecord, deleteRecord, query } from "../builders";
import { sshKeyHandler } from "./handlers";
import type { SshKey } from "./schema";

export const sshKeyList = (projectKey: string, cacheOptions?: CacheOptions) =>
  query<SshKey>(
    "sshkey/list",
    { projectkey: projectKey },
    { handler: sshKeyHandler },
    { types: ["ssh-key"], ...cacheOptions },
  );

export const sshKeyAdd = (sshKey: SshKey) =>
  createRecord<SshKey>(
    "sshkey/add",
    {
      projectkey: sshKey.project.id,
      description: sshKey.description,
      sshkey: sshKey.data,
    },
    {
      record: sshKey,
      handler: sshKeyHandler,
      listsToPatch: [sshKeyList(sshKey.project.id!)],
    },
  );

export const sshKeyRemove = (sshKey: SshKey) =>
  deleteRecord(
    "sshkey/remove",
    { sshkeyids: sshKey.id },
    {
      record: sshKey,
      handler: sshKeyHandler,
      listsToPatch: [sshKeyList(sshKey.project.id!)],
    },
  );
